import DomService from "@/scripts/core/dom.service";
import type {AbModal} from "@/scripts/modules/ab-modal/ab-modal.class";

class ModalService {

  private _domService = DomService;
  private _activeModals: AbModal[] = [];
  private _urlBeforeBackModal?: string;

  constructor() {
    window.addEventListener('popstate', (event) => {
      // At Pop State, close the last modal that handles back browser
      this.getLastModalWithBackBrowserHandling()?.hide();
    });
  }

  public isIdAvailable(modalId: string): boolean {
    return !this.getModalById(modalId);
  }

  public registerModal(modal: AbModal): void {
    this._activeModals.push(modal);
  }

  public notifyModalOpened(modalId: string): void {
    const modal = this.getModalById(modalId);
    modal.onOpen();
    this.checkBackBrowserHandling();
    this.checkBodyOverflow();
  }

  public notifyModalClosed(modalId: string): void {
    const modal = this.getModalById(modalId);
    modal.onClose();
    this._activeModals = this._activeModals
      .filter((m) =>
        m !== modal
      );
    this.checkBackBrowserHandling();
    this.checkBodyOverflow();
  }

  private checkBodyOverflow() {
    const mustHideBodyOverflow = this._activeModals
      .some((modal) =>
        modal.hideBodyOverflow && modal.isOpen
      );
    this._domService.setBodyOverflow(mustHideBodyOverflow ? 'hidden' : 'auto');
  }

  private checkBackBrowserHandling(): void {
    const lastWithBackBrowserHandling = this.getLastModalWithBackBrowserHandling();
    if (!lastWithBackBrowserHandling) {
      if (this._urlBeforeBackModal !== undefined) {
        history.replaceState(null, '', this._urlBeforeBackModal);
        this._urlBeforeBackModal = undefined;
      }
      return;
    }
    if (this._urlBeforeBackModal === undefined) {
      this._urlBeforeBackModal = window.location.pathname + window.location.search + window.location.hash;
    }
    history.replaceState(null, '', this._urlBeforeBackModal);
    history.pushState({modalOpen: true}, '', '#'+lastWithBackBrowserHandling.id);
  }

  private getLastModalWithBackBrowserHandling() {
    return this._activeModals
      .findLast( ({handleBackBrowser, isOpen}) =>
        handleBackBrowser && isOpen
      );
  }

  private getModalById(modalId: string) {
    return this._activeModals
      .find((m) =>
        m.id === modalId
      );
  }

}

export default new ModalService();


